import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Typography } from "@mui/material";
import { NotificationProps } from "src/types/NotificationProps";
import notifyStyles from "./Notify.module.css";

const NotifySuccess = ({ header, children }: NotificationProps) => {
  return (
    <Box sx={{ display: "inline" }}>
      <Box className={notifyStyles.notifyHeader}>
        <CheckCircleOutlineIcon className={notifyStyles.successIcon} />
        <Typography
          variant="h4"
          className={notifyStyles.successIcon}
        >
          {header}
        </Typography>
      </Box>
      <Box className={notifyStyles.childrenBox}>{children}</Box>
    </Box>
  );
};

export default NotifySuccess;
